import { render, staticRenderFns } from "./VideoCard.vue?vue&type=template&id=58617d08&"
import script from "./VideoCard.vue?vue&type=script&lang=js&"
export * from "./VideoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\larepublica\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58617d08')) {
      api.createRecord('58617d08', component.options)
    } else {
      api.reload('58617d08', component.options)
    }
    module.hot.accept("./VideoCard.vue?vue&type=template&id=58617d08&", function () {
      api.rerender('58617d08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/video-card/VideoCard.vue"
export default component.exports